import { Injectable } from '@angular/core';

@Injectable()
export class Global {

 IsLogged = true;
 public font = 'COVINOC';

 constructor() {
   //  console.log('esto es is logged al iniciar global', this.IsLogged);
 }

}
